import { isMobile } from 'react-device-detect';

import { ImageIcon } from 'src/ui-models/Icon';
import IconGroup from '../icon-group/IconGroup';
import { useIconGroupSectionStyles } from './IconGroupSection.styles';

interface IconGroupSectionProps {
  title: string
  items: ImageIcon[] | undefined
}

const IconGroupSection: React.FC<IconGroupSectionProps> = ({ title, items }) => {
  const styles = useIconGroupSectionStyles();
  const iconItems = items ?? [];
  const iconSize = isMobile ? 32 : 40;
  const titleStr = title?.trim() || 'Default Title';

  return (
    <div role="group" aria-labelledby={`${titleStr.toLowerCase()}-heading`} className={styles.iconGroup}>
      <p id={`${titleStr.toLowerCase()}-heading`} className={styles.iconGroupTitle}>
        {titleStr}
      </p>

      <IconGroup items={iconItems} size={iconSize} />
    </div>
  );
};

export default IconGroupSection;
